window.theme = window.theme || {};

(function () {
  var getDrawerSectionParams = function () {
    var wrapper = document.querySelector("[data-cart-drawer]");
    if (!wrapper) return null;
    var sectionId = wrapper.getAttribute("data-section-id");
    if (!sectionId) return null;
    var sectionUrl = window.location.pathname + window.location.search;
    return { id: sectionId, url: sectionUrl };
  };

  var requestJson = function (url, options) {
    return fetch(url, options).then(function (response) {
      return response.text().then(function (text) {
        var data = null;
        if (text) {
          try {
            data = JSON.parse(text);
          } catch (err) {
            data = null;
          }
        }
        if (!response.ok) {
          var error = new Error(response.statusText || "Request failed");
          error.status = response.status;
          error.responseJSON = data;
          error.responseText = text;
          throw error;
        }
        return data;
      });
    });
  };

  var toQueryParams = function (data) {
    var params = new URLSearchParams();
    if (!data) return params;
    Object.keys(data).forEach(function (key) {
      var value = data[key];
      if (Array.isArray(value)) {
        value.forEach(function (item) {
          params.append(key, item);
        });
      } else if (value !== undefined && value !== null) {
        params.append(key, value);
      }
    });
    return params;
  };

  var postFormJson = function (url, data) {
    var body =
      typeof FormData !== "undefined" && data instanceof FormData
        ? data
        : toQueryParams(data);
    return requestJson(url, {
      method: "POST",
      credentials: "same-origin",
      headers: { Accept: "application/json" },
      body: body,
    });
  };

  var getJson = function (url) {
    return requestJson(url, {
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    });
  };

  var cartItemChangeQty = function (data, success, fail, finallyCb) {
    var sectionParams = getDrawerSectionParams();
    if (sectionParams && sectionParams.id) {
      data.sections = sectionParams.id;
      if (sectionParams.url) {
        data.sections_url = sectionParams.url;
      }
    }

    postFormJson("/cart/change.js", data)
      .then(function (res) {
        if (typeof success === "function") {
          success(res);
        }
      })
      .catch(function (error) {
        if (typeof fail === "function") {
          fail(error);
        }
      })
      .finally(function () {
        if (typeof finallyCb === "function") {
          finallyCb();
        }
      });
  };

  var closest = function (target, selector) {
    if (!target) return null;
    var el = target.nodeType === 3 ? target.parentElement : target;
    if (!el || !el.closest) return null;
    return el.closest(selector);
  };

  theme.Drawer = {
    isUpdating: false,

    getDrawerWrapper: function () {
      return document.querySelector("[data-cart-drawer]");
    },

    getDrawerContent: function () {
      var wrapper = theme.Drawer.getDrawerWrapper();
      if (!wrapper) return null;
      return wrapper.querySelector("[data-cart-drawer-content]");
    },

    getSectionRequestParams: function () {
      return getDrawerSectionParams();
    },

    replaceDrawerContent: function (html) {
      var content = theme.Drawer.getDrawerContent();
      if (!content || !html) return false;
      var parsed = new DOMParser().parseFromString(html, "text/html");
      var newWrapper = parsed.querySelector("[data-cart-drawer]");
      if (!newWrapper) return false;
      var newContent = newWrapper.querySelector("[data-cart-drawer-content]");
      if (!newContent) return false;
      content.innerHTML = newContent.innerHTML;
      return true;
    },

    setLoadingState: function (isLoading) {
      theme.Drawer.isUpdating = !!isLoading;
      var wrapper = theme.Drawer.getDrawerWrapper();
      if (!wrapper) return;

      wrapper.classList.toggle("is-updating", theme.Drawer.isUpdating);

      var controls = wrapper.querySelectorAll(
        ".drawer-qty-adjust, .quantity__input"
      );
      controls.forEach(function (control) {
        control.disabled = theme.Drawer.isUpdating;
      });

      var removeLinks = wrapper.querySelectorAll(".cart-item-remove-container");
      removeLinks.forEach(function (link) {
        if (theme.Drawer.isUpdating) {
          link.setAttribute("aria-disabled", "true");
        } else {
          link.removeAttribute("aria-disabled");
        }
      });
    },

    renderCartItems: function (cart) {
      if (!cart || !Array.isArray(cart.items)) return;
      var cartItemWrapper = document.querySelector(".cart-item-wrapper");
      if (!cartItemWrapper) return;
      cartItemWrapper.innerHTML = "";
      cart.items.forEach(function (item) {
        theme.Drawer.addItemToDrawer(item);
      });
    },

    applyCartUpdate: function (cart, product, options) {
      var opts = options || {};
      var params = theme.Drawer.getSectionRequestParams();
      var sectionUpdated = false;

      if (cart && cart.sections && params && cart.sections[params.id]) {
        sectionUpdated = theme.Drawer.replaceDrawerContent(
          cart.sections[params.id]
        );
      }

      var hasCartItems = cart && Array.isArray(cart.items);
      var shouldRenderFallback =
        hasCartItems && !sectionUpdated && !opts.skipRender;

      if (shouldRenderFallback) {
        theme.Drawer.renderCartItems(cart);
        theme.Drawer.updateTotal(cart);
        theme.Drawer.buildRecommendation(cart);
        if (product !== false) {
          theme.Drawer.buildProductRecommendation(product, cart);
        }
      }

      if (cart && typeof cart.item_count !== "undefined") {
        theme.Drawer.changeCartCount(cart.item_count);
      }

      return {
        sectionUpdated: sectionUpdated,
        hasCartItems: hasCartItems,
        hasCount: cart && typeof cart.item_count !== "undefined",
      };
    },

    fetchCartData: function (product, options) {
      getJson("/cart.js")
        .then(function (newCart) {
          theme.Drawer.applyCartUpdate(newCart, product, options);
        })
        .catch(function () {});
    },

    addToCartOkay: function (product) {
      var updateResult = theme.Drawer.applyCartUpdate(product, product, {
        skipRender: true,
      });

      if (!updateResult.hasCartItems || !updateResult.hasCount) {
        theme.Drawer.fetchCartData(product, {
          skipRender: updateResult.sectionUpdated,
        });
      }

      theme.Drawer.openDrawer();
    },

    checkDrawerItems: function (product) {
      var drawerWrapper = document.querySelector(".drawer-wrapper");
      if (!drawerWrapper) return false;
      var drawerCartItems = drawerWrapper.querySelectorAll(".cart-item");
      var searchKey = product ? product.key : null;
      var itemFound = false;

      drawerCartItems.forEach(function (item) {
        var id = item.getAttribute("data-id");
        if (id === searchKey) {
          itemFound = id;
        }
      });

      return itemFound;
    },

    addItemToDrawer: function (product) {
      var isSale = false;
      var drawerWrapper = document.querySelector(".drawer-wrapper");
      if (!drawerWrapper) return;
      var cartItemWrapper = drawerWrapper.querySelector(".cart-item-wrapper");
      if (!cartItemWrapper) return;

      var price = product.discounted_price;

      var title = product.product_title;
      var url = product.url;
      url = url.split("?");
      url = url[0];
      var image = product.image;
      if (image && window.slate && slate.Image) {
        image = slate.Image.getSizedImageUrl(image, "220x220");
      }
      var quantity = product.quantity;

      var sellingPlanName = "";
      if (
        product.selling_plan_allocation &&
        product.selling_plan_allocation.selling_plan &&
        product.selling_plan_allocation.selling_plan.name
      ) {
        sellingPlanName = product.selling_plan_allocation.selling_plan.name;
      }
      var compare_price = 0;
      if (product.properties && product.properties._compareprice) {
        compare_price = product.properties._compareprice;
      }

      if (compare_price > price) {
        isSale = true;
      }

      price =
        window.slate && slate.Currency
          ? slate.Currency.formatMoney(price, theme.moneyFormat)
          : price;
      compare_price =
        window.slate && slate.Currency
          ? slate.Currency.formatMoney(compare_price, theme.moneyFormat)
          : compare_price;

      var key = product.key;
      var variant = "";

      if (product.variant_title !== null) {
        variant = product.variant_title;
      }

      var cartItem =
        `<div class="cart-item" data-id="` +
        key +
        `">
          <div class="cart-item-image">
            <img src="` +
        image +
        `">
          </div>
          <div class="cart-item-content">
            <h6 class="cart-item-title">
              <a href="` +
        url +
        `">
                 ` +
        title +
        `
              </a>
            </h6>
			<div class="cart-item-variant">
				` +
        variant +
        `
		   </div>
		   <div class="cart-item-selling-plan-name">
				` +
        sellingPlanName +
        `
		   </div>

            
            <div class="drawer-control-group">
              <div class="quantity-selector drawer-quantity-selector">
                <button data-operation="minus" class="drawer-qty-adjust js-drawer-qty-adjust quantity__minus">
					<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" viewBox="0 0 20 20"><path fill="#444" d="M17.543 11.029H2.1A1.032 1.032 0 0 1 1.071 10c0-.566.463-1.029 1.029-1.029h15.443c.566 0 1.029.463 1.029 1.029 0 .566-.463 1.029-1.029 1.029z"/></svg>
				</button>
				<input data-old-value="` +
        quantity +
        `" type="text" class="js-qty__num quantity__input" value="` +
        quantity +
        `" min="1" aria-label="quantity" pattern="[0-9]*" name="quantity">
                <button data-opeation="plus" class="drawer-qty-adjust js-drawer-qty-adjust quantity__plus">
					<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" viewBox="0 0 20 20"><path fill="#444" d="M17.409 8.929h-6.695V2.258c0-.566-.506-1.029-1.071-1.029s-1.071.463-1.071 1.029v6.671H1.967C1.401 8.929.938 9.435.938 10s.463 1.071 1.029 1.071h6.605V17.7c0 .566.506 1.029 1.071 1.029s1.071-.463 1.071-1.029v-6.629h6.695c.566 0 1.029-.506 1.029-1.071s-.463-1.071-1.029-1.071z"/></svg>
				</button>
              </div>


			  <p><span class="cart-item-price money">` +
        price +
        `</span>
				 <s class="cart_item product__price--strike hide" >` +
        compare_price +
        `</s>
		     </p>
            </div>
			
            <a class="cart-item-remove-container">
            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 20 20"><path fill="#444" d="M15.89 14.696l-4.734-4.734 4.717-4.717c.4-.4.37-1.085-.03-1.485s-1.085-.43-1.485-.03L9.641 8.447 4.97 3.776c-.4-.4-1.085-.37-1.485.03s-.43 1.085-.03 1.485l4.671 4.671-4.688 4.688c-.4.4-.37 1.085.03 1.485s1.085.43 1.485.03l4.688-4.687 4.734 4.734c.4.4.37 1.085.03 1.485s-1.085.43-1.485.03s-.43-1.085-.03-1.485z"/></svg>
            </a>
            <p class="js-cart-item-error-text cart-item-error-text"> </p>
          </div>
          
        </div>`;

      var wrapper = document.createElement("div");
      wrapper.innerHTML = cartItem;
      var cartItemEl = wrapper.firstElementChild;
      if (!cartItemEl) return;

      if (isSale) {
        var strike = cartItemEl.querySelector(".product__price--strike");
        var priceEl = cartItemEl.querySelector(".cart-item-price");
        if (strike) strike.classList.remove("hide");
        if (priceEl) priceEl.classList.add("product__price--sale");
      }

      cartItemWrapper.insertBefore(cartItemEl, cartItemWrapper.firstChild);
    },

    cartChange: function (cart, product) {
      if (cart === false) {
        theme.Drawer.fetchCartData(product);
        return;
      }

      theme.Drawer.applyCartUpdate(cart, product);
    },

    changeCartCount: function (cart_items) {
      cart_items = parseInt(cart_items, 10);
      var count = document.querySelector("#CartButton .cart-count-js");
      var bubble = document.querySelector("#CartButton .header__cart__count");

      if (cart_items > 0) {
        if (count) count.textContent = cart_items;
        if (bubble) {
          bubble.style.display = "";
          if (window.getComputedStyle(bubble).display === "none") {
            bubble.style.display = "block";
          }
          bubble.classList.add("pulse-cart-icon");
          setTimeout(function () {
            bubble.classList.remove("pulse-cart-icon");
          }, 800);
        }
      } else if (bubble) {
        bubble.style.display = "none";
      }
    },

    cartReloadPageRefresh: function () {
      var bubble = document.querySelector("#CartButton .header__cart__count");
      if (bubble) bubble.style.display = "none";
      theme.Drawer.fetchCartData(false, { skipRender: false });
    },

    cartCheck: function () {},

    updateTotal: function (cart) {
      var subtotal = cart.total_price;
      var countEls = document.querySelectorAll(".cart-count-js");
      countEls.forEach(function (el) {
        el.innerHTML = cart.item_count;
      });

      var subtotalEl = document.getElementById("drawer-subtotal-price");
      if (subtotalEl) {
        subtotalEl.innerHTML = slate.Currency.formatMoney(
          subtotal,
          theme.moneyFormat
        );
      }
    },

    showDrawer: function () {
      theme.Drawer.openDrawer();
    },

    isFreeShipping: function (cart) {
      var total_price = cart.total_price;
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        if (
          !item.selling_plan_allocation ||
          !item.selling_plan_allocation.selling_plan
        )
          continue;

        total_price -= item.final_line_price;
      }

      var freeShippingTreshold = theme.cart.freeShippingThreshold;
      var missing_amount = freeShippingTreshold - total_price;

      if (missing_amount > 0) return missing_amount;

      return true;
    },

    buildRecommendation: function (cart) {
      var footerPromoTextContainer = document.querySelector(".promo-text-js");
      if (!footerPromoTextContainer) return;

      var freeShippingTreshold = parseFloat(
        footerPromoTextContainer.getAttribute("data-freeshipping-threshold")
      );

      var isFreeShipping = theme.Drawer.isFreeShipping(cart);

      if (cart.items.length === 0) {
        var emptyText =
          `<p>` +
          theme.strings.empty_cart_text +
          `&nbsp;<a href="` +
          window.Shopify.routes.root +
          `collections"><span class="drawer-footer-emp">` +
          theme.strings.continue_shopping +
          `</span></a></p>`;
        footerPromoTextContainer.innerHTML = emptyText;
      } else if (isFreeShipping !== true) {
        var missingAmount = isFreeShipping;
        var missingAmountFormat = slate.Currency.formatMoney(
          missingAmount,
          theme.moneyFormat
        );
        var freeShippingText = "<p>" + theme.strings.cart_shipping_text + "</p>";
        freeShippingText = freeShippingText.replace(
          "{{ freeShippingDiff }}",
          missingAmountFormat
        );
        footerPromoTextContainer.innerHTML = freeShippingText;
      } else {
        var shippingText = "<p>" + theme.strings.free_shipping_text + "</p>";
        footerPromoTextContainer.innerHTML = shippingText;
      }
    },

    getProductForRecommendation: function (handle, cart, heading, callback) {
      getJson(window.Shopify.routes.root + "products/" + handle + ".js")
        .then(function (result) {
          if (!result) {
            if (typeof callback === "function") callback();
            return;
          }
          var product = {
            title: result.title,
            url: result.url,
            price: result.price,
            id: result.variants[0].id,
            image: result.featured_image,
            available: result.available,
          };

          if (product.available) {
            theme.Drawer.addProductRecommendation(product, cart, heading);
          }

          if (typeof callback === "function") callback();
        })
        .catch(function () {
          if (typeof callback === "function") callback();
        });
    },

    buildProductRecommendation: function (product, cart) {
      var suggestedContainer = document.querySelector(
        ".suggested-product-container"
      );
      var suggestedWrapper = document.querySelector(
        ".drawer-footer-suggested-products"
      );
      if (!suggestedContainer || !suggestedWrapper) return;

      var isFreeShipping = theme.Drawer.isFreeShipping(cart);
      var handle = product.handle;

      suggestedContainer.innerHTML = "";

      getJson("/products/" + handle)
        .then(function (newProduct) {
          if (!newProduct || !newProduct.product || !newProduct.product.tags) {
            return;
          }
          var tags = newProduct.product.tags.split(",");
          var suggested_handles = [];
          for (var i = 0; i < tags.length; i++) {
            if (tags[i].includes("suggested")) {
              var suggested_item = tags[i].split(":");
              suggested_handles.push(suggested_item[1]);
            }
          }

          var pairs_with_heading = theme.strings.cart_pairs_with.heading;

          if (suggested_handles.length > 0) {
            theme.Drawer.getProductForRecommendation(
              suggested_handles[0],
              cart,
              pairs_with_heading,
              function () {
                if (suggested_handles.length > 1) {
                  theme.Drawer.getProductForRecommendation(
                    suggested_handles[1],
                    cart,
                    false,
                    false
                  );
                }
              }
            );
          }
        })
        .catch(function () {});
    },

    addProductRecommendation: function (product, cart, heading) {
      var suggestedContainer = document.querySelector(
        ".suggested-product-container"
      );
      var suggestedWrapper = document.querySelector(
        ".drawer-footer-suggested-products"
      );
      if (!suggestedContainer || !suggestedWrapper) return;

      var title = product.title;
      var url = product.url;
      var price = slate.Currency.formatMoney(product.price, theme.moneyFormat);
      var img = slate.Image.getSizedImageUrl(product.image, "80x80");
      var id = product.id;
      var add_label = theme.strings.cart_pairs_with.add;

      var suggestedProductTemplate =
        `<div class="suggested-product">
                <div class="suggested-product-content">
                  <img src="` +
        img +
        `">
                  <div class="suggested-product-text">
					<a href="` +
        url +
        `">
                    <p class="suggested-product-title">` +
        title +
        `</p>
					</a>
                    <p class="suggested-product-price">` +
        price +
        `</p>
                  </div>
                </div>
				<a data-id="` +
        id +
        `" class="product-grid-add-js">
                <button class="suggested-product-cta" >
                  ` +
        add_label +
        `
                </button>
				</a>
              </div>`;

      suggestedContainer.insertAdjacentHTML("beforeend", suggestedProductTemplate);
      suggestedWrapper.style.display = "";
    },

    closeDrawer: function () {
      var drawerWrapper = document.querySelector(".drawer-wrapper");
      if (!drawerWrapper) return;

      drawerWrapper.classList.add("closing");

      setTimeout(function () {
        document.body.classList.remove("drawer-open");
        document.documentElement.classList.remove("drawer-open");

        drawerWrapper.classList.add("close");
        drawerWrapper.classList.remove("open");
        drawerWrapper.classList.remove("closing");

        window.removeEventListener("click", theme.Drawer.handleClickOutside);
      }, 800);

      var drawerMain = document.querySelector(".drawer-main");
      if (window.bodyScrollLock && drawerMain) {
        bodyScrollLock.enableBodyScroll(drawerMain);
      }
    },

    openDrawer: function () {
      var drawerWrapper = document.querySelector(".drawer-wrapper");
      if (!drawerWrapper || drawerWrapper.classList.contains("open")) return;

      if (window.theme && theme.ChatWidget && theme.ChatWidget.hide) {
        theme.ChatWidget.hide();
      }

      drawerWrapper.classList.remove("close");
      document.body.classList.add("drawer-open");
      document.documentElement.classList.add("drawer-open");
      drawerWrapper.classList.add("open");

      window.addEventListener("click", theme.Drawer.handleClickOutside);

      var drawerMain = document.querySelector(".drawer-main");
      if (window.bodyScrollLock && drawerMain) {
        bodyScrollLock.disableBodyScroll(drawerMain);
      }
    },

    handleClickOutside: function (e) {
      if (
        !closest(e.target, ".drawer-main") &&
        document.documentElement.classList.contains("drawer-open")
      ) {
        theme.Drawer.closeDrawer();
      }
    },
  };

  document.addEventListener("click", function (e) {
    var closeBtn = closest(e.target, ".drawer-close");
    if (closeBtn) {
      e.preventDefault();
      theme.Drawer.closeDrawer();
      return;
    }

    var cartButton = closest(e.target, "#CartButton");
    if (cartButton) {
      e.preventDefault();
      theme.Drawer.openDrawer();
      e.stopPropagation();
      return;
    }

    var removeBtn = closest(e.target, ".cart-item-remove-container");
    if (removeBtn) {
      e.preventDefault();
      if (theme.Drawer && theme.Drawer.isUpdating) {
        return;
      }
      var cartItem = closest(removeBtn, ".cart-item");
      if (!cartItem) return;
      var key = cartItem.getAttribute("data-id");
      var data = { quantity: 0, id: key };

      theme.Drawer.setLoadingState(true);

      var fail = function (error) {
        console.log("error: ", error);
        var errorMessage =
          (error.responseJSON && error.responseJSON.message) || "";
        var errorText = cartItem.querySelector(".js-cart-item-error-text");
        if (errorText) errorText.textContent = errorMessage;
        cartItem.classList.add("has-error");
      };

      var finallyCb = function () {
        theme.Drawer.setLoadingState(false);
      };

      var success = function (cart) {
        theme.Drawer.applyCartUpdate(cart);
      };

      cartItemChangeQty(data, success, fail, finallyCb);
      return;
    }

    var qtyAdjust = closest(e.target, ".drawer-qty-adjust");
    if (qtyAdjust) {
      e.preventDefault();
      if (theme.Drawer && theme.Drawer.isUpdating) {
        return;
      }

      var qtySelector = qtyAdjust.parentElement
        ? qtyAdjust.parentElement.querySelector(
            ".js-qty__num.quantity__input"
          )
        : null;
      if (!qtySelector) return;

      var qty = parseInt(qtySelector.value.replace(/\D/g, ""), 10);
      var cartItem = closest(qtyAdjust, ".cart-item");

      qtySelector.dataset.oldValue = qty;

      if (parseFloat(qty) !== parseInt(qty, 10) || isNaN(qty)) {
        qty = 1;
      }

      if (qtyAdjust.classList.contains("quantity__minus")) {
        qty = qty - 1;
      } else {
        qty = qty + 1;
      }

      qtySelector.value = qty;
      qtySelector.dispatchEvent(new Event("change", { bubbles: true }));
    }
  });

  document.addEventListener("change", function (e) {
    var qtyInput = closest(e.target, ".js-qty__num.quantity__input");
    if (!qtyInput) return;

    if (theme.Drawer && theme.Drawer.isUpdating) {
      return;
    }

    var qty = qtyInput.value;
    var qtyAdjust = qtyInput.parentElement
      ? qtyInput.parentElement.querySelectorAll(".js-drawer-qty-adjust")
      : [];
    var cartItem = closest(qtyInput, ".cart-item");
    if (!cartItem) return;

    var key = cartItem.getAttribute("data-id");
    var data = { quantity: qty, id: key };

    qtyInput.disabled = true;
    qtyAdjust.forEach(function (btn) {
      btn.disabled = true;
    });

    cartItem.classList.remove("has-error");

    var fail = function (error) {
      var oldValue = qtyInput.dataset.oldValue;
      if (oldValue !== undefined) {
        qtyInput.value = oldValue;
      }

      console.log("error: ", error);

      var errorMessage =
        (error.responseJSON && error.responseJSON.message) || "";

      var errorText = cartItem.querySelector(".js-cart-item-error-text");
      if (errorText) errorText.textContent = errorMessage;

      cartItem.classList.add("has-error");
    };

    var finallyCb = function () {
      qtyInput.disabled = false;
      qtyAdjust.forEach(function (btn) {
        btn.disabled = false;
      });
      theme.Drawer.setLoadingState(false);
    };

    var success = function (cart) {
      theme.Drawer.applyCartUpdate(cart);
    };

    theme.Drawer.setLoadingState(true);
    cartItemChangeQty(data, success, fail, finallyCb);
  });

  window.addEventListener("load", function () {
    theme.Drawer.cartReloadPageRefresh();
    console.log("drawer loaded");
  });

  window.addEventListener("pageshow", function (event) {
    var historyPage =
      event.persisted ||
      (typeof window.performance !== "undefined" &&
        window.performance.navigation.type === 2);
    if (historyPage) {
      theme.Drawer.cartReloadPageRefresh();
      console.log("back drawer loaded");
    }
  });
})();
